export default __webpack_public_path__ + "static/media/visa.fc72ab1f.svg";